// extracted by mini-css-extract-plugin
module.exports = {"header":"Facts_header__2-bur","card":"Facts_card__217hR","dummy":"Facts_dummy__vUISn"};